import React from "react"; 
import { Link } from "react-router-dom";    
import EditPaymentTermForm from "../../../components/Dashboard/PaymentTermsListContent/Edit";

const EditPaymentTerm = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit Payment Term</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li><Link to="/payment-terms">
              Payment Terms
            </Link></li>
          <li>Edit Payment Term</li>
        </ul>
      </div> */}

      <EditPaymentTermForm />
    </>
  );
};

export default EditPaymentTerm;
